import React from "react";
import { connect } from "react-redux";
import { Route } from "react-router-dom";

import { userManager } from "@utilities";
import { routerPath } from "@config";

const PrivateRoute = props => {
  const Com = props.component;
  let userSession = sessionStorage.getItem("admin");
  if (userSession) userSession = JSON.parse(userSession);
  const userRedux = props.admin;
  const user = userRedux ? userRedux : userSession;

  if (!user) {
    userManager.signinRedirect({
      data: {
        redirectUrl: routerPath.listKyc
      }
    });
    return <div>Redirecting to login ...</div>;
  } else {
    return (
      <Route
        exact={props.exacts}
        {...props}
        render={props => {
          return <Com {...props} />;
        }}
      />
    );
  }
};

function mapStateToProps(state) {
  return {
    admin: state.oidcReducer.user
  };
}

const connectedPrivateRoute = connect(mapStateToProps)(PrivateRoute);
export { connectedPrivateRoute as PrivateRoute };
